// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__C5n4N typography_paragraphSmall__o7w9R typography_bodyFont__ybYPk","breadcrumb":"breadcrumbs_breadcrumb__3Fm7P"};